export const parameteroptionConstants = {
    GETALL_REQUEST: 'PARAMETEROPTION_GETALL_REQUEST',
    GETALL_SUCCESS: 'PARAMETEROPTION_GETALL_SUCCESS',
    GETALL_FAILURE: 'PARAMETEROPTION_GETALL_FAILURE',

    DELETE_REQUEST: 'PARAMETEROPTION_DELETE_REQUEST',
    DELETE_SUCCESS: 'PARAMETEROPTION_DELETE_SUCCESS',
    DELETE_FAILURE: 'PARAMETEROPTION_DELETE_FAILURE'
};
